import React, { useEffect } from "react";
import { Pagination  } from 'antd';
import Card from "components/card";
import { connect } from "react-redux";
import TrainingModuleForm from "./TrainingModuleForm";
import PopupButton from "components/button/PopupButton";
import { 
	getTrainingModuleList, doTrainingModuleDelete
} from "../../../../redux/trainingmodule/trainingModuleState";
import SearchFilter from "components/search/SearchFilter";
import {MODULE_TRAINING_MOD} from "variables/constants"
import { BookOpen } from "lucide-react";
import TrainingModuleCard from "./TrainingModuleCard";


const TrainingModuleTable = ({
	recordList, 
	pagination, 
	doSearch, 
	filters, 
	doDelete,
}) => {
    
	useEffect(() => {
		doSearch({paginate: pagination.per_page});
	}, [doSearch, pagination.per_page]);
	
  	return (

		<Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-2xl border-2 border-slate-200 dark-mode-card">
			<div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6">
				<div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
					<div>
						<h4 className="text-[16px] leading-none title-text">
							Modules
						</h4>
						<p className="text-[13px] muted-text">
							Browse all available training programs - Data synced from Client access
						</p>
					</div>
					<div className="flex items-center gap-2">
						<div className="flex-1 min-w-0 sm:w-[400px]">
							<SearchFilter placeholder="Search by title..." searchHandler={doSearch} filters={filters} pagination={pagination}/>
						</div>
						<PopupButton 
							id="add_trainingModule" 
							title="Add Training Module" 
							label="Add" 
							btnClass="btn-small" 
							action="add" 
							moduleId={MODULE_TRAINING_MOD}
							useCustomClass={true}
						>
							<TrainingModuleForm recordId="0" mode="edit" />
						</PopupButton>
					</div>
				</div>
			</div>
			<div className="px-6 pb-6">
				<div className="space-y-4">
					{recordList && recordList.length > 0 ? (
						recordList.map((module) => 
							<TrainingModuleCard 
								key={module.trm_id}
								recordData={module}
								deleteHandler={doDelete}
							/>)
						) : (
						<div className="text-center py-12 muted-text">
							<BookOpen className="w-12 h-12 mx-auto mb-4"/>
							<p>No modules found matching the filters</p>
						</div>
					)}
				</div>
				<div className="flex justify-end py-4">
					<Pagination
						current={pagination.current_page}
						pageSize={pagination.per_page}
						total={pagination.total}
						showSizeChanger={false}
						onChange={(page) =>
						doSearch({
							...filters,
							page,
							paginate: pagination.per_page,
						})
						}
					/>
				</div>
			</div>
		</Card>
  	);
};

const mapStateToProps = (state) => ({
	recordList: state.trainingModule.trainingModuleList?.items,
	pagination: state.trainingModule.trainingModuleList?.pagination,
	filters: state.trainingModule.trainingModuleList?.filters,
	requesting: state.trainingModule.trainingModuleList?.requesting,
	error: state.trainingModule.trainingModuleList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getTrainingModuleList(filters)),
	doDelete: (id) => dispatch(doTrainingModuleDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingModuleTable);
